export interface Folder {
  folderId: string;
  folderName: string;
  userId: string;
  ordersCount: number;
  createdAt: string;
  updatedAt?: string;
}

export interface FolderResponse {
  folder_id?: string;
  folderId?: string;
  folder_name?: string;
  folderName?: string;
  user_id?: string;
  userId?: string;
  orders_count?: number;
  ordersCount?: number;
  created_at?: string;
  createdAt?: string;
  updated_at?: string;
  updatedAt?: string;
}

export function parseFolder(data: FolderResponse): Folder {
  return {
    folderId: data.folder_id || data.folderId || '',
    folderName: data.folder_name || data.folderName || '',
    userId: data.user_id || data.userId || '',
    ordersCount: data.orders_count ?? data.ordersCount ?? 0,
    createdAt: data.created_at || data.createdAt || new Date().toISOString(),
    updatedAt: data.updated_at || data.updatedAt,
  };
}

